import { propertyContextQueryCache } from "src/data/propertyContext/propertyContextQueryCache"
import { useMinutQuery } from "src/hooks/minutQuery"

export function useFetchPropertyContexts({ orgId }: { orgId: string }) {
  return useMinutQuery<"/organizations/{organization_id}/property_context">({
    queryKey: propertyContextQueryCache.propertyContextList(orgId),
    queryPath: `/organizations/${orgId}/property_context`,
    apiPath: "/organizations/{organization_id}/property_context",
  })
}
